import React, { useEffect, useState } from 'react'
import { Container } from '@mui/material'
import { IContactUsForm, IReducer } from '../../interface'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import ContactUsForm from '../../components/ContactUs/ContactUsForm'
import { sendEmailToTrainingGQL } from 'src/services/graphql/schemas/emails'
import { NotificationManager } from 'src/functions/notifications'
import { FormattedMessage } from 'react-intl'
import { getCountryName, getRecaptchaToken, getStateName } from 'src/utils'
import { useCookies } from 'react-cookie'
import { useRecaptcha } from 'src/customHooks/useRecaptcha'

const ContactUsTraining = (props: { selectedProduct: string }) => {
  const navigate = useNavigate()
  const [initialValuesData, setInitialValuesData] = useState({})
  const userInfo = useSelector((state: IReducer) => state.accountReducer.userInfo)
  const isAuthenticated = useSelector((state: IReducer) => state.accountReducer.isAuthenticated)
  const [isLoading, setLoading] = useState(false)
  const { selectedProduct } = props
  const [cookies] = useCookies(['country_code'])
  const [countryCode, setCountryCode] = useState<string | undefined>(cookies.country_code?.toUpperCase())
  const { recaptchaToken, handleTokenChange } = useRecaptcha()

  /**
   * Calls sendEmailToTrainingGQL, if it returns status code 200, confirmation url is pushed into the history
   * @function onSubmit
   * @param {IContactUsForm} values - values of the form.
   * @returns  void
   */
  const onSubmit = async (values: IContactUsForm) => {
    setLoading(true)
    const { name, email, phone, comment, country, state, organization } = values
    let userData
    let stateName
    if (userInfo) {
      userData = {
        FirstName: name,
        Email: email,
        PhoneNumber: phone,
        AccountNumber: userInfo.DefaultShipToAccount
      }
      const countryName = getCountryName(country)
      if (state) stateName = getStateName(state)
      if (countryName && stateName) {
        const success = await sendEmailToTrainingGQL(
          userData,
          selectedProduct,
          comment,
          countryName,
          stateName,
          organization,
          getRecaptchaToken(recaptchaToken)
        )
        if (success === 200) {
          NotificationManager.success(<FormattedMessage id='notification.messageSent' />)
          return navigate('/private-classes/confirmation', { replace: true })
        } else {
          NotificationManager.error(<FormattedMessage id='notification.systemError' />)
        }
      }
      setLoading(false)
    }
  }

  const cancelRequest = () => {
    navigate('/store', { replace: true })
  }

  useEffect(() => {
    if (!selectedProduct) {
      cancelRequest()
    }
  }, [])

  useEffect(() => {
    if (isAuthenticated) {
      setInitialValuesData({
        name: userInfo.FirstName,
        email: userInfo.Email,
        phone: userInfo.BillToAccountObj.PhoneNumber,
        AccountNumber: userInfo.DefaultShipToAccount,
        country: countryCode,
        organization: userInfo.BillToAccountObj.CompanyName,
        state: 'none'
      })
    }
  }, [])

  return (
    <Container data-gtm-click-section={selectedProduct} data-cy='contactus-container'>
      <ContactUsForm
        isLoading={isLoading}
        initialValuesData={initialValuesData}
        onSubmit={onSubmit}
        disabledField={true}
        countryCode={countryCode}
        setCountryCode={setCountryCode}
        recaptchaToken={recaptchaToken}
        handleTokenChange={handleTokenChange}
      />
    </Container>
  )
}

export default ContactUsTraining
